import type { TokenManagerData } from '../types/token-manager';

import { widgetApi } from '../../config';

export const getVkIdInternalApi = async (
  widgetUuid: string,
  silent: string,
  uuid: string
): Promise<TokenManagerData | undefined> => {
  const data = {
    widgetUuid,
    silent,
    uuid,
  };

  try {
    const result = await fetch(`${widgetApi}/auth/vk/internal`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    const json: TokenManagerData = await result.json();
    return json;
  } catch (error: unknown) {
    if (typeof error === 'string') {
      throw new Error(error);
    }
  }
};
